import Splide from '@splidejs/splide'

const mobileGallery = window.matchMedia('(max-width: 767.98px)')

function mountGallerySlider(el) {
    if (el.splide) return
    el.splide = new Splide(el, {
        type: 'slide',
        perPage: 1,
        arrows: false,
        pagination: false,
    }).mount()
}

export default function productGallery() {
    document.querySelectorAll('[data-product-gallery] [data-gallery-splide]').forEach((el) => {
        const root = el.closest('[data-product-gallery]') || el
        root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => el.splide?.go('<'))
        root.querySelector('[data-gallery-next]')?.addEventListener('click', () => el.splide?.go('>'))
        const sync = () => {
            if (!mobileGallery.matches) {
                el.splide?.destroy()
                el.splide = null
                return
            }
            mountGallerySlider(el)
        }
        sync()
        mobileGallery.addEventListener('change', sync)
    })

    document.querySelectorAll('[data-product-gallery]').forEach((root) => {
        const main = root.querySelector('[data-gallery-main]')
        if (!main) return
        root.querySelectorAll('[data-gallery-thumb]').forEach((btn) => {
            btn.addEventListener('click', () => {
                const src = btn.dataset.src
                if (!src) return
                const thumbImg = btn.querySelector('img')
                const prevSrc = main.currentSrc || main.src
                const prevAlt = main.alt
                main.src = src
                main.alt = btn.dataset.alt || ''
                btn.dataset.src = prevSrc
                btn.dataset.alt = prevAlt
                if (thumbImg) thumbImg.src = prevSrc
            })
        })
    })
}
